export const getHTagNumber = text => {
  var _exec;
  const hTag = (_exec = /<h(?<heading>[1-6])\b/u.exec(text)) == null ? void 0 : _exec[1];
  return hTag ? parseInt(hTag, 10) : undefined;
};
//# sourceMappingURL=get-h-tag-number.js.map